/**
 * Property Refinement
 */


if (jQuery().select2) {

    function updateURLParameter(url, param, paramVal) {
        var TheAnchor = null;
        var newAdditionalURL = "";
        var tempArray = url.split("?");
        var baseURL = tempArray[0];
        var additionalURL = tempArray[1];
        var temp = "";

        if (additionalURL) {
            var tmpAnchor = additionalURL.split("#");
            var TheParams = tmpAnchor[0];
            TheAnchor = tmpAnchor[1];
            if (TheAnchor)
                additionalURL = TheParams;

            tempArray = additionalURL.split("&");

            for (var i = 0; i < tempArray.length; i++) {
                if (tempArray[i].split('=')[0] != param) {
                    newAdditionalURL += temp + tempArray[i];
                    temp = "&";
                }
            }
        } else {
            var tmpAnchor = baseURL.split("#");
            var TheParams = tmpAnchor[0];
            TheAnchor = tmpAnchor[1];

            if (TheParams)
                baseURL = TheParams;
        }

        if (TheAnchor)
            paramVal += "#" + TheAnchor;

        var rows_txt = temp + "" + param + "=" + paramVal;
        return baseURL + "?" + newAdditionalURL + rows_txt;
    }


    function pushURL(param, value) {
        url = window.location.href;
        newURL = updateURLParameter(url, param, value);
        history.pushState(null, null, newURL);
    }

    function changeMultiSelectParameters(select_val, value_name) {
        url = window.location.href;
        $.post("/functions/mls/changeurlformultiselect.php", {'url': url, 'array_items': select_val, 'value_name': value_name}, function (data) {
            history.pushState('', '', data.result)
        });
    }


    //https://stackoverflow.com/questions/26730167/how-to-pre-select-values-in-select2-multi-select
    //how you populate array

    var expire = new Date();
    //set expiry to current time plus 15 minutes in milliseconds
    expire.setTime(expire.getTime() + (15 * 60 * 1000));

    // we use this configuration for multiselect
    $("#property_city").on("change", function (e) {

        var select_val = $(e.currentTarget).val();
        // we need to check and see if we have multiple items in the array.
            if ($.isArray(select_val)) {
                // if we do have multiple items then check to see if the first item is empty
                // this means they have selected "any" and cities together so we need to fix this
                if (select_val.length[0] !== '') {

                    // the filter functions takes out any empty strings
                    select_val = select_val.filter(function (v) {
                        return v !== ''
                    });
                    $.cookie("property_city", select_val, {expires: expire, path: '/'});

                    // we need to push the changes to select to and then we can save a cookie below
                    $('#property_city').val($.cookie("property_city").split(",")).trigger('change.select2');

                    // we need to update the query string in the browser history.
                    changeMultiSelectParameters(select_val, 'property_city');

                }
            } else {
                $.cookie("property_city", select_val, {expires: expire, path: '/'});
                // we need to update the query string in the browser history.
                changeMultiSelectParameters(select_val);
            }

    });

    if ($.cookie("property_city")) {
        //var arrayCity = $.cookie("city").split(",");
        $('#property_city').val($.cookie("property_city").split(",")).trigger('change.select2');
    } else {
        $('#property_city').val($.cookie("property_city")).trigger('change.select2');
    }


    $("#property_type").on("change", function (e) {

        var select_val = $(e.currentTarget).val();
        // we need to check and see if we have multiple items in the array.


            if ($.isArray(select_val)) {
                // if we do have multiple items then check to see if the first item is empty
                // this means they have selected "any" and cities together so we need to fix this
                if (select_val.length[0] !== '') {

                    // the filter functions takes out any empty strings
                    select_val = select_val.filter(function (v) {
                        return v !== ''
                    });


                    $.cookie("property_type", select_val, {expires: expire, path: '/'});

                    console.log($.cookie("property_type"));

                    // we need to push the changes to select to and then we can save a cookie below
                    $('#property_type').val($.cookie("property_type").split(",")).trigger('change.select2');

                    // we need to update the query string in the browser history.
                    changeMultiSelectParameters(select_val, 'property_type');

                }
            } else {
                console.log($.cookie("property_type"));
                $.cookie("property_type", select_val, {expires: expire, path: '/'});
                // we need to update the query string in the browser history.
                changeMultiSelectParameters(select_val);
            }

    });

    //console.log($.cookie("property_type"));

    if ($.cookie("property_type")) {
        $('#property_type').val($.cookie("property_type").split(",")).trigger('change.select2');
    } else {
        $('#property_type').val($.cookie("property_type")).trigger('change.select2');
    }


    $("#property_bedrooms").on("select2:select", function (e) {
        var select_val = $(e.currentTarget).val();
        $.cookie("property_bedrooms", select_val, {expires: expire, path: '/'});
        pushURL('property_bedrooms', select_val);
    });
    $('#property_bedrooms').val($.cookie("property_bedrooms")).trigger('change.select2');


    $("#property_min_price").on("select2:select", function (e) {
        var select_val = $(e.currentTarget).val();
        $.cookie("property_min_price", select_val, {expires: expire, path: '/'});
        pushURL('property_min_price', select_val);
    });
    $('#property_min_price').val($.cookie("property_min_price")).trigger('change.select2');


    $("#property_max_price").on("select2:select", function (e) {
        var select_val = $(e.currentTarget).val();
        $.cookie("property_max_price", select_val, {expires: expire, path: '/'});
        pushURL('property_max_price', select_val);
    });
    $('#property_max_price').val($.cookie("property_max_price")).trigger('change.select2');

    /*$("#property_city").on("select2:select", function (e) {
        var select_val = $(e.currentTarget).val();
        $.cookie("city", select_val, { expires: expire });
    });*/
    //$('#property_city').val($.cookie("city")).trigger('change.select2');

    $("#property_bathrooms").on("select2:select", function (e) {
        var select_val = $(e.currentTarget).val();
        $.cookie("property_bathrooms", select_val, {expires: expire, path: '/'});
        pushURL('property_bathrooms', select_val);
    });
    $('#property_bathrooms').val($.cookie("property_bathrooms")).trigger('change.select2');


    $("#property_min-area").on("keyup", function (e) {
        var select_val = $(e.currentTarget).val();
        $.cookie("property_min-area", select_val, {expires: expire, path: '/'});
        pushURL('property_min-area', select_val);
    });
    $('#property_min-area').val($.cookie("property_min-area")).trigger('change.select2');


    $("#property_max-area").on("keyup", function (e) {
        var select_val = $(e.currentTarget).val();
        $.cookie("property_max-area", select_val, {expires: expire, path: '/'});
        pushURL('property_max-area', select_val);

    });
    $('#property_max-area').val($.cookie("property_max-area")).trigger('change.select2');

    $("#property_keyword").on("keyup", function (e) {
        var select_val = $(e.currentTarget).val();
        $.cookie("property_keyword", select_val, {expires: expire, path: '/'});
        pushURL('property_keyword', select_val);

    });
    $('#property_keyword').val($.cookie("property_keyword")).trigger('change.select2');


    $("#property_max_garage").on("select2:select", function (e) {
        var select_val = $(e.currentTarget).val();
        $.cookie("property_max_garage", select_val, {expires: expire, path: '/'});
        pushURL('property_max_garage', select_val);

    });
    $('#property_max_garage').val($.cookie("property_max_garage")).trigger('change.select2');


    $("#property_min_lot_size").on("select2:select", function (e) {
        var select_val = $(e.currentTarget).val();
        $.cookie("property_min_lot_size", select_val, {expires: expire, path: '/'});
        pushURL('property_min_lot_size', select_val);
    });
    $('#property_min_lot_size').val($.cookie("property_min_lot_size")).trigger('change.select2');


    $("#property_max_lot_size").on("select2:select", function (e) {
        var select_val = $(e.currentTarget).val();
        $.cookie("property_max_lot_size", select_val, {expires: expire, path: '/'});
        pushURL('property_max_lot_size', select_val);
    });
    $('#property_max_lot_size').val($.cookie("property_max_lot_size")).trigger('change.select2');

    $("#property_area").on("select2:select", function (e) {
        var select_val = $(e.currentTarget).val();
        $.cookie("property_area", select_val, {expires: expire, path: '/'});
        pushURL('property_area', select_val);
    });
    $('#property_area').val($.cookie("property_area")).trigger('change.select2');


    $("#property_address").on("select2:select", function (e) {
        var select_val = $(e.currentTarget).val();
        $.cookie("property_address", select_val, {expires: expire, path: '/'});
        pushURL('property_address', select_val);
    });
    $('#property_address').val($.cookie("property_address")).trigger('change.select2');

    $("#property_year").on("keyup", function (e) {
        var select_val = $(e.currentTarget).val();
        $.cookie("property_year", select_val, {expires: expire, path: '/'});
        pushURL('property_year', select_val);
    });
    $('#property_year').val($.cookie("property_year")).trigger('change.select2');

    $("#property_sub").on("select2:select", function (e) {
        var select_val = $(e.currentTarget).val();
        $.cookie("property_sub", select_val, {expires: expire, path: '/'});
        pushURL('property_sub', select_val);
    });
    $('#property_sub').val($.cookie("property_sub")).trigger('change.select2');

    $("#property_zoning").on("select2:select", function (e) {
        var select_val = $(e.currentTarget).val();
        $.cookie("property_zoning", select_val, {expires: expire, path: '/'});
        pushURL('property_zoning', select_val);
    });
    $('#property_zoning').val($.cookie("property_zoning")).trigger('change.select2');


    $("#private_pool").on("change", function (e) {
        if($(this).prop("checked"))  {
            select_val = 1;
        } else {
            select_val = 0;
        }
        $.cookie("private_pool", select_val, {expires: expire, path: '/'});
        pushURL('private_pool', (select_val * 1));
    });
    $('#private_pool').prop('checked', ($.cookie("private_pool") * 1)).trigger('change.select2');

    $("#fifty_five").on("change", function (e) {
        if($(this).prop("checked"))  {
            select_val = 1;
        } else {
            select_val = 0;
        }
        $.cookie("fifty_five", select_val, {expires: expire, path: '/'});
        pushURL('fifty_five', (select_val * 1));
    });
    $('#fifty_five').prop('checked', ($.cookie("fifty_five") * 1)).trigger('change.select2');


    $("#horse").on("change", function (e) {
        if($(this).prop("checked"))  {
            select_val = 1;
        } else {
            select_val = 0;
        }
        $.cookie("horse", select_val, {expires: expire, path: '/'});
        pushURL('horse', (select_val * 1));
    });
    $('#horse').prop('checked', ($.cookie("horse") * 1)).trigger('change.select2');

    $("#rv_garage").on("change", function (e) {
        if($(this).prop("checked"))  {
            select_val = 1;
        } else {
            select_val = 0;
        }
        $.cookie("rv_garage", select_val, {expires: expire, path: '/'});
        pushURL('rv_garage', (select_val * 1));
    });
    $('#rv_garage').prop('checked', ($.cookie("rv_garage") * 1)).trigger('change.select2');

    $("#rv_parking").on("change", function (e) {
        if($(this).prop("checked"))  {
            select_val = 1;
        } else {
            select_val = 0;
        }
        $.cookie("rv_parking", select_val, {expires: expire, path: '/'});
        pushURL('rv_parking', (select_val * 1));
    });
    $('#rv_parking').prop('checked', ($.cookie("rv_parking") * 1)).trigger('change.select2');

    $("#solar_panels").on("change", function (e) {
        if($(this).prop("checked"))  {
            select_val = 1;
        } else {
            select_val = 0;
        }
        $.cookie("solar_panels", select_val, {expires: expire, path: '/'});
        pushURL('solar_panels', (select_val * 1));
    });
    $('#solar_panels').prop('checked', ($.cookie("solar_panels") * 1)).trigger('change.select2');

    $("#mother_in_law").on("change", function (e) {
        if($(this).prop("checked"))  {
            select_val = 1;
        } else {
            select_val = 0;
        }
        $.cookie("mother_in_law", select_val, {expires: expire, path: '/'});
        pushURL('mother_in_law', (select_val * 1));
    });
    $('#mother_in_law').prop('checked', ($.cookie("mother_in_law") * 1)).trigger('change.select2');

    $("#casita").on("change", function (e) {
        if($(this).prop("checked"))  {
            select_val = 1;
        } else {
            select_val = 0;
        }
        $.cookie("casita", select_val, {expires: expire, path: '/'});
        pushURL('casita', (select_val * 1));
    });
    $('#casita').prop('checked', ($.cookie("casita") * 1)).trigger('change.select2');


    $("#bank_owned").on("change", function (e) {
        if($(this).prop("checked"))  {
            select_val = 1;
        } else {
            select_val = 0;
        }
        $.cookie("bank_owned", select_val, {expires: expire, path: '/'});
        pushURL('bank_owned', (select_val * 1));
    });
    $('#bank_owned').prop('checked', ($.cookie("bank_owned") * 1)).trigger('change.select2');


    $("#golf_course").on("change", function (e) {
        if($(this).prop("checked"))  {
            select_val = 1;
        } else {
            select_val = 0;
        }
        $.cookie("golf_course", select_val, {expires: expire, path: '/'});
        pushURL('golf_course', (select_val * 1));
    });
    $('#golf_course').prop('checked', ($.cookie("golf_course") * 1)).trigger('change.select2');


    $("#seller_financing").on("change", function (e) {
        if($(this).prop("checked"))  {
            select_val = 1;
        } else {
            select_val = 0;
        }
        $.cookie("seller_financing", select_val, {expires: expire, path: '/'});
        pushURL('casita', (select_val * 1));
    });
    $('#seller_financing').prop('checked', ($.cookie("seller_financing") * 1)).trigger('change.select2');

    $("#vacation_rentals").on("change", function (e) {
        if($(this).prop("checked"))  {
            select_val = 1;
        } else {
            select_val = 0;
        }
        $.cookie("vacation_rentals", select_val, {expires: expire, path: '/'});
        pushURL('vacation_rentals', (select_val * 1));
    });
    $('#vacation_rentals').prop('checked', ($.cookie("vacation_rentals") * 1)).trigger('change.select2');




    const $select2 = $('.property-refinement__select2');
    const selectOptions = {
        width: 'off',
    };

    $select2.select2(selectOptions)
        .on("select2:open", function (e) {
            $(this).parents('.property-refinement__select').addClass('property-refinement__active');
            $('.select2-dropdown').hide();
            setTimeout(function () {
                $('.select2-dropdown').slideDown(200);
            }, 10);
        })
        .on("select2:closing", function (e) {
            $(this).parents('.property-refinement__select').removeClass('property-refinement__active');
        });
}

$('.search-buttons__advance-btn').on('click', function (e) {

    $(this).find('#property-refinement__search').toggle('400');

    $(this).toggleClass('is-active');

    if ($(this).hasClass('is-active')) {
        $('.property-refinement__collapsed-fields').slideDown(400);
        //$('.property-refinement__collapsed-fields').css( "position: relative");
    } else (
        $('.property-refinement__collapsed-fields').slideUp(400)
    )

});

//Open Search Form More Features fields
$('#property-refinement__open-more-options').on('click', function (e) {
    e.preventDefault();

    $(this).toggleClass('is-active');

    $('.property-refinement__more-options').slideToggle(200);
});


$('.clear-search').on('click', function (e) {

    var expire = new Date();
    //set expiry to current time plus 15 minutes in milliseconds
    expire.setTime(expire.getTime() + (15 * 60 * 1000));


    $.cookie("property_type", "", {expires: expire, path: '/'});
    $.cookie("property_bedrooms", "", {expires: expire, path: '/'});
    $.cookie("property_min_price", "", {expires: expire, path: '/'});
    $.cookie("property_max_price", "", {expires: expire, path: '/'});
    $.cookie("property_city", "", {expires: expire, path: '/'});
    $.cookie("property_bathrooms", "", {expires: expire, path: '/'});
    $.cookie("property_min-area", "", {expires: expire, path: '/'});
    $.cookie("property_max-area", "", {expires: expire, path: '/'});
    $.cookie("property_address", "", {expires: expire, path: '/'});
    $.cookie("property_keyword'", "", {expires: expire, path: '/'});
    $.cookie("property_area", "", {expires: expire, path: '/'});
    $.cookie("property_max_lot_size", "", {expires: expire, path: '/'});
    $.cookie("property_min_lot_size", "", {expires: expire, path: '/'});
    $.cookie("property_max_garage", "", {expires: expire, path: '/'});
    $.cookie("property_sub", "", {expires: expire, path: '/'});
    $.cookie("property_year", "", {expires: expire, path: '/'});
    $.cookie("property_zoning", "", {expires: expire, path: '/'});
    $.cookie("property_pool", "0", {expires: expire, path: '/'});
    $.cookie("fifty_five", "0", {expires: expire, path: '/'});
    $.cookie("horse", "0", {expires: expire, path: '/'});
    $.cookie("rv_garage", "0", {expires: expire, path: '/'});
    $.cookie("rv_parking", "0", {expires: expire, path: '/'});
    $.cookie("solar_panels", "0", {expires: expire, path: '/'});
    $.cookie("casita", "0", {expires: expire, path: '/'});
    $.cookie("bank_owned", "0", {expires: expire, path: '/'});
    $.cookie("golf_course", "0", {expires: expire, path: '/'});
    $.cookie("seller_financing", "0", {expires: expire, path: '/'});
    $.cookie("mother_in_law", "0", {expires: expire, path: '/'});
    $.cookie("vacation_rentals", "0", {expires: expire, path: '/'});


    $('#property_type').val("").trigger('change.select2');
    $('#property_bedrooms').val("").trigger('change.select2');
    $('#property_min_price').val("").trigger('change.select2');
    $('#property_max_price').val("").trigger('change.select2');
    $('#property_city').val("").trigger('change.select2');
    $('#property_bathrooms').val("").trigger('change.select2');
    $('#property_min-area').val("").trigger('change.select2');
    $('#property_max-area').val("").trigger('change.select2');

    $('#property_area').val("").trigger('change.select2');
    $('#property_keyword').val("").trigger('change.select2');
    $('#property_address').val("").trigger('change.select2');

    $('#property_min_lot_size').val("").trigger('change.select2');
    $('#property_max_lot_size').val("").trigger('change.select2');
    $('#property_max_garage').val("").trigger('change.select2');
    $('#property_sub').val("").trigger('change.select2');
    $('#property_year').val("").trigger('change.select2');
    $('#property_zoning').val("").trigger('change.select2');

    // select boxes
    $('#private_pool').prop('checked', false).trigger('change.select2');
    $('#fifty_five').prop('checked', false).trigger('change.select2');
    $('#horse').prop('checked', false).trigger('change.select2');
    $('#rv_garage').prop('checked', false).trigger('change.select2');
    $('#rv_parking').prop('checked', false).trigger('change.select2');
    $('#solar_panels').prop('checked', false).trigger('change.select2');
    $('#casita').prop('checked', false).trigger('change.select2');
    $('#bank_owned').prop('checked', false).trigger('change.select2');
    $('#golf_course').prop('checked', false).trigger('change.select2');
    $('#seller_financing').prop('checked', false).trigger('change.select2');
    $('#mother_in_law').prop('checked', false).trigger('change.select2');
    $('#vacation_rentals').prop('checked', false).trigger('change.select2');

});

